<template>
    <div class="container-monitor-wrapper">
        <div class="bg-img-wrap">
            <h2 style="position: absolute; top: 0; left: 0;">冷站监控</h2>
            <!-- <el-popover
                placement="top-start"
                width="200"
                trigger="click"
                v-model="lengzhanDatavisible"
            >
                <div class="clearfix">
                    <el-button
                        style="float: right;margin-bottom: 0.5rem"
                        type="text"
                        icon="el-icon-close"
                        @click="lengzhanDatavisible = false"
                    ></el-button>
                </div>
                <div
                    class="popupdiv"
                    v-for="item in lengzhanData"
                    :key="item.key"
                >
                    <i>{{ item.key }}</i
                    >：{{ item.value }}
                </div>
                <div slot="reference" class="tab_item_select">冷站数据</div>
            </el-popover> -->
            <div style="position:absolute;bottom: 0;right: 0">
                <img
                    style="width: 7rem;height :auto;"
                    src="../../../../assets/image/leaderpage/kongtiaotuli.png"
                    alt
                    srcset
                />
            </div>
            <div class="total-wrap" id="main" ref="main">
                <div
                    id="canvas"
                    ref="canvas"
                    class="canvas-wrap"
                    :style="
                        `transform: scale(${scale});width:${width};height:${height};top:${top}px;left:${left}px`
                    "
                >
                    <img
                        class="bg-img"
                        src="../../../../assets/image/leaderpage/container-monitor-bg.png"
                        alt
                        srcset
                    />
                    <el-popover
                        placement="right"
                        width="630"
                        trigger="click"
                        v-model="lengquetaDatavisible"
                    >
                        <div class="clearfix">
                            <el-button
                                style="float: right;margin-bottom: 0.5rem"
                                type="text"
                                icon="el-icon-close"
                                @click="lengquetaDatavisible = false"
                            ></el-button>
                        </div>
                        <el-table
                            :data="lengquetaData"
                            class="leader-style-table"
                        >
                            <el-table-column
                                width="180"
                                property="type"
                                label=""
                            ></el-table-column>
                            <el-table-column
                                width="150"
                                property="one"
                                label="1#冷却塔"
                            ></el-table-column>
                            <el-table-column
                                width="150"
                                property="two"
                                label="2#冷却塔"
                            ></el-table-column>
                            <el-table-column
                                width="150"
                                property="three"
                                label="3#冷却塔"
                            ></el-table-column>
                        </el-table>
                        <img
                            class="lengqueta"
                            style="top: 10.5%;left: 12%;"
                            src="../../../../assets/image/leaderpage/lengqueta.png"
                            alt
                            srcset
                            slot="reference"
                        />
                    </el-popover>
                    <el-popover
                        placement="top-start"
                        width="700"
                        trigger="click"
                        v-model="lengquebengzongvisible1"
                    >
                        <!--                        <div-->
                        <!--                            class="popupdiv"-->
                        <!--                            v-for="item in lengquebeng1"-->
                        <!--                            :key="item.key"-->
                        <!--                        >-->
                        <!--                            <i>{{ item.key }}</i-->
                        <!--                            >：{{ item.value }}-->
                        <!--                        </div>-->
                        <div class="clearfix">
                            <el-button
                                style="float: right;margin-bottom: 0.5rem"
                                type="text"
                                icon="el-icon-close"
                                @click="lengquebengzongvisible1 = false"
                            ></el-button>
                        </div>
                        <el-table
                            :data="lengquebengzong"
                            width="100%"
                            class="leader-style-table"
                        >
                            <el-table-column
                                property="key"
                                label=""
                            ></el-table-column>
                            <el-table-column
                                property="value1"
                                label="1#冷却泵"
                            ></el-table-column>
                            <el-table-column
                                property="value2"
                                label="2#冷却泵"
                            ></el-table-column>
                            <el-table-column
                                property="value3"
                                label="3#冷却泵"
                            ></el-table-column>
                            <el-table-column
                                property="value4"
                                label="4#冷却泵"
                            ></el-table-column>
                        </el-table>
                        <img
                            class="lengquebeng"
                            style="top:27.5%;left: 12.7%"
                            src="../../../../assets/image/leaderpage/lengquebeng.png"
                            alt
                            srcset
                            slot="reference"
                        />
                    </el-popover>
                    <el-popover
                        placement="top-start"
                        width="700"
                        trigger="click"
                        v-model="lengquebengzongvisible2"
                    >
                        <!--                        <div-->
                        <!--                            class="popupdiv"-->
                        <!--                            v-for="item in lengquebeng2"-->
                        <!--                            :key="item.key"-->
                        <!--                        >-->
                        <!--                            <i>{{ item.key }}</i-->
                        <!--                            >：{{ item.value }}-->
                        <!--                        </div>-->
                        <div class="clearfix">
                            <el-button
                                style="float: right;margin-bottom: 0.5rem"
                                type="text"
                                icon="el-icon-close"
                                @click="lengquebengzongvisible2 = false"
                            ></el-button>
                        </div>
                        <el-table
                            :data="lengquebengzong"
                            width="100%"
                            class="leader-style-table"
                        >
                            <el-table-column
                                property="key"
                                label=""
                            ></el-table-column>
                            <el-table-column
                                property="value1"
                                label="1#冷却泵"
                            ></el-table-column>
                            <el-table-column
                                property="value2"
                                label="2#冷却泵"
                            ></el-table-column>
                            <el-table-column
                                property="value3"
                                label="3#冷却泵"
                            ></el-table-column>
                            <el-table-column
                                property="value4"
                                label="4#冷却泵"
                            ></el-table-column>
                        </el-table>
                        <img
                            class="lengquebeng"
                            style="top:45.5%;left: 12.7%"
                            src="../../../../assets/image/leaderpage/lengquebeng.png"
                            alt
                            srcset
                            slot="reference"
                        />
                    </el-popover>
                    <el-popover
                        placement="top-start"
                        width="700"
                        trigger="click"
                        v-model="lengquebengzongvisible3"
                    >
                        <!--                        <div-->
                        <!--                            class="popupdiv"-->
                        <!--                            v-for="item in lengquebeng3"-->
                        <!--                            :key="item.key"-->
                        <!--                        >-->
                        <!--                            <i>{{ item.key }}</i-->
                        <!--                            >：{{ item.value }}-->
                        <!--                        </div>-->
                        <div class="clearfix">
                            <el-button
                                style="float: right;margin-bottom: 0.5rem"
                                type="text"
                                icon="el-icon-close"
                                @click="lengquebengzongvisible3 = false"
                            ></el-button>
                        </div>
                        <el-table
                            :data="lengquebengzong"
                            width="100%"
                            class="leader-style-table"
                        >
                            <el-table-column
                                property="key"
                                label=""
                            ></el-table-column>
                            <el-table-column
                                property="value1"
                                label="1#冷却泵"
                            ></el-table-column>
                            <el-table-column
                                property="value2"
                                label="2#冷却泵"
                            ></el-table-column>
                            <el-table-column
                                property="value3"
                                label="3#冷却泵"
                            ></el-table-column>
                            <el-table-column
                                property="value4"
                                label="4#冷却泵"
                            ></el-table-column>
                        </el-table>
                        <img
                            class="lengquebeng"
                            style="top:64%;left: 12.7%"
                            src="../../../../assets/image/leaderpage/lengquebeng.png"
                            alt
                            srcset
                            slot="reference"
                        />
                    </el-popover>
                    <el-popover
                        placement="top-start"
                        width="700"
                        trigger="click"
                        v-model="lengquebengzongvisible4"
                    >
                        <!--                        <div-->
                        <!--                            class="popupdiv"-->
                        <!--                            v-for="item in lengquebeng4"-->
                        <!--                            :key="item.key"-->
                        <!--                        >-->
                        <!--                            <i>{{ item.key }}</i-->
                        <!--                            >：{{ item.value }}-->
                        <!--                        </div>-->
                        <div class="clearfix">
                            <el-button
                                style="float: right;margin-bottom: 0.5rem"
                                type="text"
                                icon="el-icon-close"
                                @click="lengquebengzongvisible4 = false"
                            ></el-button>
                        </div>
                        <el-table
                            :data="lengquebengzong"
                            width="100%"
                            class="leader-style-table"
                        >
                            <el-table-column
                                property="key"
                                label=""
                            ></el-table-column>
                            <el-table-column
                                property="value1"
                                label="1#冷却泵"
                            ></el-table-column>
                            <el-table-column
                                property="value2"
                                label="2#冷却泵"
                            ></el-table-column>
                            <el-table-column
                                property="value3"
                                label="3#冷却泵"
                            ></el-table-column>
                            <el-table-column
                                property="value4"
                                label="4#冷却泵"
                            ></el-table-column>
                        </el-table>
                        <img
                            class="lengquebeng"
                            style="top:77%;left: 12.7%"
                            src="../../../../assets/image/leaderpage/lengquebeng.png"
                            alt
                            srcset
                            slot="reference"
                        />
                    </el-popover>
                    <el-popover
                        placement="right"
                        width="800"
                        trigger="click"
                        v-model="zhilengzhujizongvisible1"
                    >
                        <div class="clearfix">
                            <el-button
                                style="float: right;margin-bottom: 0.5rem"
                                type="text"
                                icon="el-icon-close"
                                @click="zhilengzhujizongvisible1 = false"
                            ></el-button>
                        </div>
                        <div class="popupwrapper">
                            <!--                            <div-->
                            <!--                                class="popupdiv"-->
                            <!--                                v-for="item in zhilengzhuji1"-->
                            <!--                                :key="item.key"-->
                            <!--                            >-->
                            <!--                                <i>{{ item.key }}</i-->
                            <!--                                >：{{ item.value }}-->
                            <!--                            </div>-->
                            <el-scrollbar style="height: 100%">
                                <el-table
                                    :data="zhilengzhujizong"
                                    width="100%"
                                    class="leader-style-table"
                                >
                                    <el-table-column
                                        property="key"
                                        label=""
                                    ></el-table-column>
                                    <el-table-column
                                        property="value1"
                                        label="1#主机"
                                    ></el-table-column>
                                    <el-table-column
                                        property="value2"
                                        label="2#主机"
                                    ></el-table-column>
                                    <el-table-column
                                        property="value3"
                                        label="3#主机"
                                    ></el-table-column>
                                </el-table>
                            </el-scrollbar>
                        </div>
                        <img
                            class="zhileng"
                            style="top:41%;left: 37.5%"
                            src="../../../../assets/image/leaderpage/zhileng.png"
                            alt
                            srcset
                            slot="reference"
                        />
                    </el-popover>
                    <el-popover
                        placement="right"
                        width="800"
                        trigger="click"
                        v-model="zhilengzhujizongvisible2"
                    >
                        <div class="clearfix">
                            <el-button
                                style="float: right;margin-bottom: 0.5rem"
                                type="text"
                                icon="el-icon-close"
                                @click="zhilengzhujizongvisible2 = false"
                            ></el-button>
                        </div>
                        <div class="popupwrapper">
                            <!--                            <div-->
                            <!--                                class="popupdiv"-->
                            <!--                                v-for="item in zhilengzhuji2"-->
                            <!--                                :key="item.key"-->
                            <!--                            >-->
                            <!--                                <i>{{ item.key }}</i-->
                            <!--                                >：{{ item.value }}-->
                            <!--                            </div>-->
                            <el-scrollbar style="height: 100%">
                                <el-table
                                    :data="zhilengzhujizong"
                                    width="100%"
                                    class="leader-style-table"
                                >
                                    <el-table-column
                                        property="key"
                                        label=""
                                    ></el-table-column>
                                    <el-table-column
                                        property="value1"
                                        label="1#主机"
                                    ></el-table-column>
                                    <el-table-column
                                        property="value2"
                                        label="2#主机"
                                    ></el-table-column>
                                    <el-table-column
                                        property="value3"
                                        label="3#主机"
                                    ></el-table-column>
                                </el-table>
                            </el-scrollbar>
                        </div>
                        <img
                            class="zhileng"
                            style="top:59%;left: 37.5%"
                            src="../../../../assets/image/leaderpage/zhileng.png"
                            alt
                            srcset
                            slot="reference"
                        />
                    </el-popover>
                    <el-popover
                        placement="top-start"
                        width="800"
                        trigger="click"
                        v-model="zhilengzhujizongvisible3"
                    >
                        <div class="clearfix">
                            <el-button
                                style="float: right;margin-bottom: 0.5rem;"
                                type="text"
                                icon="el-icon-close"
                                @click="zhilengzhujizongvisible3 = false"
                            ></el-button>
                        </div>
                        <div class="popupwrapper">
                            <!--                            <div-->
                            <!--                                class="popupdiv"-->
                            <!--                                v-for="item in zhilengzhuji3"-->
                            <!--                                :key="item.key"-->
                            <!--                            >-->
                            <!--                                <i>{{ item.key }}</i-->
                            <!--                                >：{{ item.value }}-->
                            <!--                            </div>-->
                            <el-scrollbar style="height: 100%">
                                <el-table
                                    :data="zhilengzhujizong"
                                    width="100%"
                                    class="leader-style-table"
                                >
                                    <el-table-column
                                        property="key"
                                        label=""
                                    ></el-table-column>
                                    <el-table-column
                                        property="value1"
                                        label="1#主机"
                                    ></el-table-column>
                                    <el-table-column
                                        property="value2"
                                        label="2#主机"
                                    ></el-table-column>
                                    <el-table-column
                                        property="value3"
                                        label="3#主机"
                                    ></el-table-column>
                                </el-table>
                            </el-scrollbar>
                        </div>
                        <img
                            class="zhileng"
                            style="top:73.5%;left: 37.5%"
                            src="../../../../assets/image/leaderpage/zhileng.png"
                            alt
                            srcset
                            slot="reference"
                        />
                    </el-popover>
                    <el-popover
                        placement="top-start"
                        width="700"
                        trigger="click"
                        v-model="lengdongbengzongvisible1"
                    >
                        <!--                        <div-->
                        <!--                            class="popupdiv"-->
                        <!--                            v-for="item in lengdongbeng1"-->
                        <!--                            :key="item.key"-->
                        <!--                        >-->
                        <!--                            <i>{{ item.key }}</i-->
                        <!--                            >：{{ item.value }}-->
                        <!--                        </div>-->
                        <div class="clearfix">
                            <el-button
                                style="float: right;margin-bottom: 0.5rem"
                                type="text"
                                icon="el-icon-close"
                                @click="lengdongbengzongvisible1 = false"
                            ></el-button>
                        </div>
                        <el-table
                            :data="lengdongbengzong"
                            width="100%"
                            class="leader-style-table"
                        >
                            <el-table-column
                                property="key"
                                label=""
                            ></el-table-column>
                            <el-table-column
                                property="value1"
                                label="1#冷冻泵"
                            ></el-table-column>
                            <el-table-column
                                property="value2"
                                label="2#冷冻泵"
                            ></el-table-column>
                            <el-table-column
                                property="value3"
                                label="3#冷冻泵"
                            ></el-table-column>
                            <el-table-column
                                property="value4"
                                label="4#冷冻泵"
                            ></el-table-column>
                        </el-table>
                        <img
                            class="lengquebeng"
                            style="top:27.5%;left: 59.5%"
                            src="../../../../assets/image/leaderpage/lengquebeng.png"
                            alt
                            srcset
                            slot="reference"
                        />
                    </el-popover>
                    <el-popover
                        placement="top-start"
                        width="700"
                        trigger="click"
                        v-model="lengdongbengzongvisible2"
                    >
                        <!--                        <div-->
                        <!--                            class="popupdiv"-->
                        <!--                            v-for="item in lengdongbeng2"-->
                        <!--                            :key="item.key"-->
                        <!--                        >-->
                        <!--                            <i>{{ item.key }}</i-->
                        <!--                            >：{{ item.value }}-->
                        <!--                        </div>-->
                        <div class="clearfix">
                            <el-button
                                style="float: right;margin-bottom: 0.5rem"
                                type="text"
                                icon="el-icon-close"
                                @click="lengdongbengzongvisible2 = false"
                            ></el-button>
                        </div>
                        <el-table
                            :data="lengdongbengzong"
                            width="100%"
                            class="leader-style-table"
                        >
                            <el-table-column
                                property="key"
                                label=""
                            ></el-table-column>
                            <el-table-column
                                property="value1"
                                label="1#冷冻泵"
                            ></el-table-column>
                            <el-table-column
                                property="value2"
                                label="2#冷冻泵"
                            ></el-table-column>
                            <el-table-column
                                property="value3"
                                label="3#冷冻泵"
                            ></el-table-column>
                            <el-table-column
                                property="value4"
                                label="4#冷冻泵"
                            ></el-table-column>
                        </el-table>
                        <img
                            class="lengquebeng"
                            style="top:45.5%;left: 59.5%"
                            src="../../../../assets/image/leaderpage/lengquebeng.png"
                            alt
                            srcset
                            slot="reference"
                        />
                    </el-popover>
                    <el-popover
                        placement="top-start"
                        width="700"
                        trigger="click"
                        v-model="lengdongbengzongvisible3"
                    >
                        <!--                        <div-->
                        <!--                            class="popupdiv"-->
                        <!--                            v-for="item in lengdongbeng3"-->
                        <!--                            :key="item.key"-->
                        <!--                        >-->
                        <!--                            <i>{{ item.key }}</i-->
                        <!--                            >：{{ item.value }}-->
                        <!--                        </div>-->
                        <div class="clearfix">
                            <el-button
                                style="float: right;margin-bottom: 0.5rem"
                                type="text"
                                icon="el-icon-close"
                                @click="lengdongbengzongvisible3 = false"
                            ></el-button>
                        </div>
                        <el-table
                            :data="lengdongbengzong"
                            width="100%"
                            class="leader-style-table"
                        >
                            <el-table-column
                                property="key"
                                label=""
                            ></el-table-column>
                            <el-table-column
                                property="value1"
                                label="1#冷冻泵"
                            ></el-table-column>
                            <el-table-column
                                property="value2"
                                label="2#冷冻泵"
                            ></el-table-column>
                            <el-table-column
                                property="value3"
                                label="3#冷冻泵"
                            ></el-table-column>
                            <el-table-column
                                property="value4"
                                label="4#冷冻泵"
                            ></el-table-column>
                        </el-table>
                        <img
                            class="lengquebeng"
                            style="top:63.5%;left: 59.5%"
                            src="../../../../assets/image/leaderpage/lengquebeng.png"
                            alt
                            srcset
                            slot="reference"
                        />
                    </el-popover>
                    <el-popover
                        placement="top-start"
                        width="700"
                        trigger="click"
                        v-model="lengdongbengzongvisible4"
                    >
                        <!--                        <div-->
                        <!--                            class="popupdiv"-->
                        <!--                            v-for="item in lengdongbeng4"-->
                        <!--                            :key="item.key"-->
                        <!--                        >-->
                        <!--                            <i>{{ item.key }}</i-->
                        <!--                            >：{{ item.value }}-->
                        <!--                        </div>-->
                        <div class="clearfix">
                            <el-button
                                style="float: right;margin-bottom: 0.5rem"
                                type="text"
                                icon="el-icon-close"
                                @click="lengdongbengzongvisible4 = false"
                            ></el-button>
                        </div>
                        <el-table
                            :data="lengdongbengzong"
                            width="100%"
                            class="leader-style-table"
                        >
                            <el-table-column
                                property="key"
                                label=""
                            ></el-table-column>
                            <el-table-column
                                property="value1"
                                label="1#冷冻泵"
                            ></el-table-column>
                            <el-table-column
                                property="value2"
                                label="2#冷冻泵"
                            ></el-table-column>
                            <el-table-column
                                property="value3"
                                label="3#冷冻泵"
                            ></el-table-column>
                            <el-table-column
                                property="value4"
                                label="4#冷冻泵"
                            ></el-table-column>
                        </el-table>
                        <img
                            class="lengquebeng"
                            style="top:77.2%;left: 59.5%"
                            src="../../../../assets/image/leaderpage/lengquebeng.png"
                            alt
                            srcset
                            slot="reference"
                        />
                    </el-popover>
                    <!-- 显示 T和P 的地方 -->
                    <div
                        v-for="item in datasT"
                        :key="item.id"
                        class="data-wrap"
                        :style="`top:${item.top};left:${item.left};`"
                        @click="showdialog(item)"
                    >
                        <div class="data-item">
                            <div class="data-name red">{{ item.tname }}</div>
                            <div class="data-number diagram-input-bg">
                                {{ item.t }}<span>℃</span>
                            </div>
                        </div>
                        <div class="data-item">
                            <div class="data-name yellow">{{ item.pname }}</div>
                            <div class="data-number diagram-input-bg">
                                {{ item.p }}<span>MPa</span>
                            </div>
                        </div>
                    </div>
                    <!-- 只显示P的地方 -->
                    <div
                        v-for="item in datasP"
                        :key="item.id"
                        class="data-wrap"
                        :style="`top:${item.top};left:${item.left};`"
                        @click="showdialog(item)"
                    >
                        <div class="data-item" v-if="'yin' != item.pname">
                            <div class="data-name yellow">{{ item.pname }}</div>
                            <div class="data-number diagram-input-bg">
                                {{ item.p }}<span>MPa</span>
                            </div>
                        </div>
                    </div>
                    <!-- 运行状态  图片 -->
                    <div
                        v-for="item in datasState"
                        :key="item.id"
                        class="data-wrap"
                        :style="`top:${item.top};left:${item.left};`"
                    >
                        <img
                            style="height: 1.5rem; width: auto;"
                            src="../../../../assets/image/leaderpage/tingzhi.png"
                            alt
                            srcset
                            v-show="item.run_state == 0"
                        />
                        <img
                            style="height: 1.5rem; width: auto;"
                            src="../../../../assets/image/leaderpage/yunxing.gif"
                            alt
                            srcset
                            v-show="item.run_state == 1"
                        />
                    </div>
                    <!-- 故障状态  图片 -->
                    <div
                        v-for="item in datasState"
                        :key="item.id"
                        class="data-wrap"
                        :style="`top:${item._top};left:${item._left};`"
                    >
                        <img
                            style="height: 1.2rem; width: auto;"
                            src="../../../../assets/image/leaderpage/guzhang.png"
                            alt
                            srcset
                            v-show="item.error_state == 1"
                        />
                    </div>
                    <!-- 右下角冷量表 -->
                    <div class="data-wrap" style="top:20%;left:63%;">
                        <div class="data-item">
                            <div class="data-name green">R1</div>
                            <div class="data-number diagram-input-bg">
                                {{ lengzhanflow }}<span>m³/s</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
// import * as api from "@/http/api-diagram.js";

export default {
    components: {},
    data() {
        return {
            left: "-30",
            top: "0",
            scale: 0.9,
            basisUnitV: 1,
            basisUnitH: 1,
            diagramType: 2,
            timer: "",
            detailVisible: false,
            dialogTitle: "",
            biaoNumber: "",
            datasT: [
                {
                    id: 0,
                    t: 0,
                    p: 0,
                    tname: "T1",
                    pname: "P1",
                    top: "18.6%",
                    left: "2.66%"
                },
                {
                    // 2#制冷主机
                    id: 1,
                    t: 0,
                    p: 0,
                    tname: "T2",
                    pname: "P3",
                    top: "71.6%",
                    left: "29.36%"
                },
                {
                    // 3#制冷主机
                    id: 2,
                    t: 0,
                    p: 0,
                    tname: "T3",
                    pname: "P5",
                    top: "56.6%",
                    left: "30.36%"
                },
                {
                    // 1#制冷主机
                    id: 3,
                    t: 0,
                    p: 0,
                    tname: "T4",
                    pname: "P7",
                    top: "35.6%",
                    left: "35.36%"
                },
                {
                    id: 4,
                    t: 0,
                    p: 0,
                    tname: "T5",
                    pname: "P8",
                    top: "21.6%",
                    left: "53.36%"
                },
                {
                    id: 5,
                    t: 0,
                    p: 0,
                    tname: "T6",
                    pname: "P12",
                    top: "75.6%",
                    left: "66.36%"
                }
                // {
                //     id: 6,
                //     t: 0,
                //     p: 0,
                //     t7: 0,
                //     p13: 0,
                //     top: "70.6%",
                //     left: "80.36%",
                // },
                // {
                //     id: 7,
                //     t: 0,
                //     p: 0,
                //     t8: 0,
                //     p14: 0,
                //     top: "87.6%",
                //     left: "80.36%",
                // },
            ],
            datasP: [
                {
                    // 左侧#4冷却泵
                    id: 0,
                    p: 0,
                    pname: "p2",
                    top: "74.6%",
                    left: "19.36%"
                },
                {
                    //左侧3#冷却泵
                    id: 1,
                    p: 0,
                    pname: "p4",
                    top: "60.6%",
                    left: "19.36%"
                },
                {
                    //左侧2#冷却泵
                    id: 2,
                    p: 0,
                    pname: "p6",
                    top: "42.6%",
                    left: "19.36%"
                },
                {
                    //左侧1#冷却泵
                    id: 3,
                    p: 0,
                    pname: "yin",
                    top: "-10%",
                    left: "-10%"
                },
                {
                    // 右侧4#冷却泵
                    id: 4,
                    p: 0,
                    pname: "p9",
                    top: "89.6%",
                    left: "56.36%"
                },
                {
                    // 右侧3#冷却泵
                    id: 5,
                    p: 0,
                    pname: "p10",
                    top: "59.6%",
                    left: "56.36%"
                },
                {
                    // 右侧2#冷却泵
                    id: 6,
                    p: 0,
                    pname: "p11",
                    top: "42.6%",
                    left: "56.36%"
                },
                {
                    // 右侧1#冷却泵
                    id: 7,
                    p: 0,
                    pname: "yin", //冷冻泵1#
                    top: "-100%",
                    left: "-100%"
                }
            ],
            datasState: [
                {
                    id: 0,
                    run_state: null,
                    error_state: null,
                    name: "1#冷却塔",
                    top: "9.2%",
                    left: "17.26%",
                    _top: "15.5%",
                    _left: "16.56%"
                },
                {
                    id: 1,
                    run_state: null,
                    error_state: null,
                    name: "2#冷却塔",
                    top: "10%",
                    left: "14.16%",
                    _top: "15.5%",
                    _left: "14.56%"
                },
                {
                    id: 2,
                    run_state: null,
                    error_state: null,
                    name: "3#冷却塔",
                    top: "10.8%",
                    left: "11.86%",
                    _top: "15.5%",
                    _left: "12.86%"
                },
                {
                    id: 3,
                    run_state: null,
                    error_state: null,
                    name: "4#冷却泵",
                    top: "78.4%",
                    left: "16.16%",
                    _top: "79%",
                    _left: "18.16%"
                },
                {
                    id: 4,
                    run_state: null,
                    error_state: null,
                    name: "3#冷却泵",
                    top: "65.4%",
                    left: "16.16%",
                    _top: "66.5%",
                    _left: "18.16%"
                },
                {
                    id: 5,
                    run_state: null,
                    error_state: null,
                    name: "2#冷却泵",
                    top: "46.9%",
                    left: "16.16%",
                    _top: "48%",
                    _left: "18.16%"
                },
                {
                    id: 6,
                    run_state: null,
                    error_state: null,
                    name: "1#冷却泵",
                    top: "28.9%",
                    left: "16.16%",
                    _top: "30%",
                    _left: "18.16%"
                },
                {
                    id: 7,
                    run_state: null,
                    error_state: null,
                    name: "3#制冷主机",
                    top: "40%",
                    left: "44%",
                    _top: "28.2%",
                    _left: "40.16%"
                },
                {
                    id: 8,
                    run_state: null,
                    error_state: null,
                    name: "2#制冷主机",
                    top: "60%",
                    left: "44%",
                    _top: "46.2%",
                    _left: "40.16%"
                },
                {
                    id: 9,
                    run_state: null,
                    error_state: null,
                    name: "1#制冷主机",
                    top: "80%",
                    left: "44%",
                    _top: "63.8%",
                    _left: "40.16%"
                },
                {
                    id: 10,
                    run_state: null,
                    error_state: null,
                    name: "4#冷冻泵",
                    top: "79%",
                    left: "61.66%",
                    _top: "80%",
                    _left: "60.06%"
                },
                {
                    id: 11,
                    run_state: null,
                    error_state: null,
                    name: "3#冷冻泵",
                    top: "65.5%",
                    left: "61.66%",
                    _top: "66.5%",
                    _left: "60.06%"
                },
                {
                    id: 12,
                    run_state: null,
                    error_state: null,
                    name: "2#冷冻泵",
                    top: "47.5%",
                    left: "61.66%",
                    _top: "48.5%",
                    _left: "60.06%"
                },
                {
                    id: 13,
                    run_state: null,
                    error_state: null,
                    name: "1#冷冻泵",
                    top: "29.5%",
                    left: "61.66%",
                    _top: "31%",
                    _left: "60.06%"
                }
            ],
            lengquetaData: [], //冷却塔
            lengquetaDatavisible: false,
            lengzhanData: null, //冷站公共数据
            lengzhanDatavisible: false,
            lengquebeng4: [], //4#冷却泵
            lengquebeng3: [], //3#冷却泵
            lengquebeng2: [], //2#冷却泵
            lengquebeng1: [], //1#冷却泵
            lengquebengzong: [], //整理冷却泵
            lengquebengzongvisible1: false,
            lengquebengzongvisible2: false,
            lengquebengzongvisible3: false,
            lengquebengzongvisible4: false,
            zhilengzhuji3: [], //3#制冷主机
            zhilengzhuji2: [], //2#制冷主机
            zhilengzhuji1: [], //1#制冷主机
            zhilengzhujizong: [], //整理制冷主机
            zhilengzhujizongvisible1: false,
            zhilengzhujizongvisible2: false,
            zhilengzhujizongvisible3: false,
            lengdongbeng4: [], //4#冷冻泵
            lengdongbeng3: [], //3#冷冻泵
            lengdongbeng2: [], //2#冷冻泵
            lengdongbeng1: [], //1#冷冻泵
            lengdongbengzong: [], //整理冷冻泵
            lengdongbengzongvisible1: false,
            lengdongbengzongvisible2: false,
            lengdongbengzongvisible3: false,
            lengdongbengzongvisible4: false,
            lengzhanflow: "", //冷站冷量表R1
            updateTime: ""
        };
    },
    mounted() {
        this.zoom();
        this.drag();
        // this.queryDatas();
        this.setImgSize();
        window.onresize = () => {
            this.setImgSize();
        };
    },
    created() {
        // this.timer = setInterval(() => {
        //     this.queryDatas();
        // }, 10000);
    },
    methods: {
        queryDatas() {
            this.getColdstation();
            this.getColdPunmp();
            this.getColdEngine();
            this.getCryoPunmp();
            this.getColdTowerFan();
        },
        getColdstation() {
            //冷站数据  公共数据
            api.getColdstation(["lz_togetherlz_collector"]).then(res => {
                if (res) {
                    const data = res.bus_json["lz_togetherlz_collector"];
                    // T1  P1
                    this.datasT[0].t = data
                        ? data.cold_punmp_all_out_water_temp
                        : "--";
                    this.datasT[0].p = data
                        ? data.cold_punmp_all_out_water_bar
                        : "--";
                    // T5  P8
                    this.datasT[4].t = data
                        ? data.cryo_punmp_all_out_water_temp
                        : "--";
                    this.datasT[4].p = data
                        ? data.cryo_punmp_all_out_water_bar
                        : "--";
                    // T6  P12
                    this.datasT[5].t = data
                        ? data.cryo_punmp_all_back_water_temp
                        : "--";
                    this.datasT[5].p = data
                        ? data.cryo_punmp_all_back_water_bar
                        : "--";
                    this.lengzhanflow = data ? data.instantaneous_flow : "--";
                    this.lengzhanData = [
                        {
                            key: "冷却总供水温度(℃)",
                            value: data
                                ? data.cold_punmp_all_out_water_temp
                                : "--"
                        },
                        {
                            key: "冷冻总供水温度(℃)",
                            value: data
                                ? data.cryo_punmp_all_out_water_temp
                                : "--"
                        },
                        {
                            key: "冷冻总回水温度(℃)",
                            value: data
                                ? data.cryo_punmp_all_back_water_temp
                                : "--"
                        },
                        {
                            key: "冷却总供水压力",
                            value: data
                                ? data.cold_punmp_all_out_water_bar
                                : "--"
                        },
                        {
                            key: "冷冻总供水压力",
                            value: data
                                ? data.cryo_punmp_all_out_water_bar
                                : "--"
                        },
                        {
                            key: "冷冻总回水压力",
                            value: data
                                ? data.cryo_punmp_all_back_water_bar
                                : "--"
                        },
                        {
                            key: "室外温度(℃)",
                            value: data ? data.out_temp : "--"
                        },
                        {
                            key: "室外湿度(RH)",
                            value: data ? data.out_humidity : "--"
                        },
                        {
                            key: "瞬时流量(m³/s)",
                            value: data ? data.instantaneous_flow : "--"
                        },
                        {
                            key: "累计冷量(kW)",
                            value: data ? data.meter_cold_count : "--"
                        },
                        {
                            key: "阀门开度(0-100%)",
                            value: data ? data.valve_opening : "--"
                        },
                        {
                            key: "整体能耗(kWh)",
                            value: data ? data.all_power_used : "--"
                        },
                        {
                            key: "整体运行状态",
                            value:
                                data.all_run_state == 0
                                    ? "停止"
                                    : data.all_run_state == 1
                                    ? "运行"
                                    : "--"
                        }
                    ];
                }
            });
        },
        getColdTowerFan() {
            //冷却塔
            api.getColdTowerFan([
                "ltfj_togethercold_tower_fan-1",
                "ltfj_togethercold_tower_fan-2",
                "ltfj_togethercold_tower_fan-3"
            ]).then(res => {
                if (res) {
                    const data1 = res.bus_json["ltfj_togethercold_tower_fan-1"];
                    const data2 = res.bus_json["ltfj_togethercold_tower_fan-2"];
                    const data3 = res.bus_json["ltfj_togethercold_tower_fan-3"];
                    this.lengquetaData = [
                        {
                            type: "运行状态",
                            one:
                                data1.run_state == 0
                                    ? "停止"
                                    : data1.run_state == 1
                                    ? "运行"
                                    : "--",
                            two:
                                data2.run_state == 0
                                    ? "停止"
                                    : data2.run_state == 1
                                    ? "运行"
                                    : "--",
                            three:
                                data3.run_state == 0
                                    ? "停止"
                                    : data3.run_state == 1
                                    ? "运行"
                                    : "--"
                        },
                        {
                            type: "本地/远控状态",
                            one:
                                data1.local_remote_state == 0
                                    ? "本地"
                                    : data1.local_remote_state == 1
                                    ? "远控"
                                    : "--",
                            two:
                                data2.local_remote_state == 0
                                    ? "本地"
                                    : data2.local_remote_state == 1
                                    ? "远控"
                                    : "--",
                            three:
                                data3.local_remote_state == 0
                                    ? "本地"
                                    : data3.local_remote_state == 1
                                    ? "远控"
                                    : "--"
                        },
                        {
                            type: "故障状态",
                            one:
                                data1.error_state == 0
                                    ? "无故障"
                                    : data1.error_state == 1
                                    ? "故障"
                                    : "--",
                            two:
                                data2.error_state == 0
                                    ? "无故障"
                                    : data2.error_state == 1
                                    ? "故障"
                                    : "--",
                            three:
                                data3.error_state == 0
                                    ? "无故障"
                                    : data3.error_state == 1
                                    ? "故障"
                                    : "--"
                        },
                        {
                            type: "变频运行频率(Hz)",
                            one: data1 ? data1.frequency : "--",
                            two: data2 ? data2.frequency : "--",
                            three: data3 ? data3.frequency : "--"
                        }
                    ];
                    //3个冷却塔的运行和故障状态
                    this.datasState[0].run_state = data1
                        ? data1.run_state
                        : "--";
                    this.datasState[0].error_state = data1
                        ? data1.error_state
                        : "--";
                    this.datasState[1].run_state = data2
                        ? data2.run_state
                        : "--";
                    this.datasState[1].error_state = data2
                        ? data2.error_state
                        : "--";
                    this.datasState[2].run_state = data3
                        ? data3.run_state
                        : "--";
                    this.datasState[2].error_state = data3
                        ? data3.error_state
                        : "--";
                }
            });
        },
        getColdPunmp() {
            //冷却泵
            api.getColdPunmp([
                "lqb_togethercold_punmp-1",
                "lqb_togethercold_punmp-2",
                "lqb_togethercold_punmp-3",
                "lqb_togethercold_punmp-4"
            ]).then(res => {
                if (res) {
                    const data1 = res.bus_json["lqb_togethercold_punmp-1"];
                    //冷却泵1#出口压力
                    this.datasP[3].p = data1 ? data1.out_bar : "--";
                    const data2 = res.bus_json["lqb_togethercold_punmp-2"];
                    //冷却泵2#出口压力
                    this.datasP[2].p = data2 ? data2.out_bar : "--";
                    const data3 = res.bus_json["lqb_togethercold_punmp-3"];
                    //冷却泵3#出口压力
                    this.datasP[1].p = data3 ? data3.out_bar : "--";
                    const data4 = res.bus_json["lqb_togethercold_punmp-4"];
                    //冷却泵4#出口压力
                    this.datasP[0].p = data4 ? data4.out_bar : "--";
                    // 状态
                    this.datasState[6].run_state = data1
                        ? data1.run_state
                        : "--";
                    this.datasState[6].error_state = data1
                        ? data1.error_state
                        : "--";
                    this.datasState[5].run_state = data2
                        ? data2.run_state
                        : "--";
                    this.datasState[5].error_state = data2
                        ? data2.error_state
                        : "--";
                    this.datasState[4].run_state = data3
                        ? data3.run_state
                        : "--";
                    this.datasState[4].error_state = data3
                        ? data3.error_state
                        : "--";
                    this.datasState[3].run_state = data4
                        ? data4.run_state
                        : "--";
                    this.datasState[3].error_state = data4
                        ? data4.error_state
                        : "--";
                    this.lengquebeng4 = [
                        {
                            key: "运行状态",
                            value:
                                data4.run_state == 0
                                    ? "停止"
                                    : data4.run_state == 1
                                    ? "运行"
                                    : "--"
                        },
                        {
                            key: "本地/远控状态",
                            value:
                                data4.local_remote_state == 0
                                    ? "本地"
                                    : data4.local_remote_state == 1
                                    ? "远控"
                                    : "--"
                        },
                        {
                            key: "故障状态",
                            value:
                                data4.error_state == 0
                                    ? "无故障"
                                    : data4.local_remote_state == 1
                                    ? "故障"
                                    : "--"
                        },
                        {
                            key: "出口压力(MPa)",
                            value: data4 ? data4.out_bar : "--"
                        },
                        {
                            key: "变频运行频率(Hz)",
                            value: data4 ? data4.frequency : "--"
                        }
                    ];
                    this.lengquebeng3 = [
                        {
                            key: "运行状态",
                            value:
                                data3.run_state == 0
                                    ? "停止"
                                    : data3.run_state == 1
                                    ? "运行"
                                    : "--"
                        },
                        {
                            key: "本地/远控状态",
                            value:
                                data3.local_remote_state == 0
                                    ? "本地"
                                    : data3.local_remote_state == 1
                                    ? "远控"
                                    : "--"
                        },
                        {
                            key: "故障状态",
                            value:
                                data3.error_state == 0
                                    ? "无故障"
                                    : data3.local_remote_state == 1
                                    ? "故障"
                                    : "--"
                        },
                        {
                            key: "出口压力(MPa)",
                            value: data3 ? data3.out_bar : "--"
                        },
                        {
                            key: "变频运行频率(Hz)",
                            value: data3 ? data3.frequency : "--"
                        }
                    ];
                    this.lengquebeng2 = [
                        {
                            key: "运行状态",
                            value:
                                data2.run_state == 0
                                    ? "停止"
                                    : data2.run_state == 1
                                    ? "运行"
                                    : "--"
                        },
                        {
                            key: "本地/远控状态",
                            value:
                                data2.local_remote_state == 0
                                    ? "本地"
                                    : data2.local_remote_state == 1
                                    ? "远控"
                                    : "--"
                        },
                        {
                            key: "故障状态",
                            value:
                                data2.error_state == 0
                                    ? "无故障"
                                    : data2.local_remote_state == 1
                                    ? "故障"
                                    : "--"
                        },
                        {
                            key: "出口压力(MPa)",
                            value: data2 ? data2.out_bar : "--"
                        },
                        {
                            key: "变频运行频率(Hz)",
                            value: data2 ? data2.frequency : "--"
                        }
                    ];
                    this.lengquebeng1 = [
                        {
                            key: "运行状态",
                            value:
                                data1.run_state == 0
                                    ? "停止"
                                    : data1.run_state == 1
                                    ? "运行"
                                    : "--"
                        },
                        {
                            key: "本地/远控状态",
                            value:
                                data1.local_remote_state == 0
                                    ? "本地"
                                    : data1.local_remote_state == 1
                                    ? "远控"
                                    : "--"
                        },
                        {
                            key: "故障状态",
                            value:
                                data1.error_state == 0
                                    ? "无故障"
                                    : data1.local_remote_state == 1
                                    ? "故障"
                                    : "--"
                        },
                        {
                            key: "出口压力(MPa)",
                            value: data1 ? data1.out_bar : "--"
                        },
                        {
                            key: "变频运行频率(Hz)",
                            value: data1 ? data1.frequency : "--"
                        }
                    ];

                    this.lengquebengzong = [];
                    for (var i = 0; i < this.lengquebeng1.length; i++) {
                        let item = {};
                        item.key = this.lengquebeng1[i].key;
                        item.value1 = this.lengquebeng1[i].value;
                        item.value2 = this.lengquebeng2[i].value;
                        item.value3 = this.lengquebeng3[i].value;
                        item.value4 = this.lengquebeng4[i].value;
                        this.lengquebengzong.push(item);
                    }
                    console.log(this.lengquebengzong);
                }
            });
        },
        getColdEngine() {
            //制冷主机
            api.getColdEngine([
                "lsj_togethercold_engine-1",
                "lsj_togethercold_engine-2",
                "lsj_togethercold_engine-3"
            ]).then(res => {
                if (res) {
                    const engine1 = res.bus_json["lsj_togethercold_engine-1"];
                    //T4 P7
                    this.datasT[3].t = engine1
                        ? engine1.cold_water_out_temp
                        : "--";
                    this.datasT[3].p = engine1
                        ? engine1.cold_water_out_bar
                        : "--";
                    const engine2 = res.bus_json["lsj_togethercold_engine-2"];
                    // T3 P5
                    this.datasT[1].t = engine2
                        ? engine2.cold_water_out_temp
                        : "--";
                    this.datasT[1].p = engine2
                        ? engine2.cold_water_out_bar
                        : "--";
                    const engine3 = res.bus_json["lsj_togethercold_engine-3"];
                    //T2  P3
                    this.datasT[2].t = engine3
                        ? engine3.cold_water_out_temp
                        : "--";
                    this.datasT[2].p = engine3
                        ? engine3.cold_water_out_bar
                        : "--";
                    // 状态
                    // this.datasState[7].run_state = engine3
                    //     ? engine3.run_state
                    //     : "--";
                    // this.datasState[7].error_state = engine3
                    //     ? engine3.error_state
                    //     : "--";
                    // this.datasState[8].run_state = engine2
                    //     ? engine2.run_state
                    //     : "--";
                    // this.datasState[8].error_state = engine2
                    //     ? engine2.error_state
                    //     : "--";
                    // this.datasState[9].run_state = engine1
                    //     ? engine1.run_state
                    //     : "--";
                    // this.datasState[9].error_state = engine1
                    //     ? engine1.error_state
                    //     : "--";
                    this.datasState[7].run_state = engine1
                        ? engine1.run_state
                        : "--";
                    this.datasState[7].error_state = engine1
                        ? engine1.error_state
                        : "--";
                    this.datasState[8].run_state = engine2
                        ? engine2.run_state
                        : "--";
                    this.datasState[8].error_state = engine2
                        ? engine2.error_state
                        : "--";
                    this.datasState[9].run_state = engine3
                        ? engine3.run_state
                        : "--";
                    this.datasState[9].error_state = engine3
                        ? engine3.error_state
                        : "--";
                    this.zhilengzhuji1 = [
                        {
                            key: "运行状态",
                            value:
                                engine1.run_state == 0
                                    ? "停止"
                                    : engine1.run_state == 1
                                    ? "运行"
                                    : "--"
                        },
                        {
                            key: "故障状态",
                            value:
                                engine1.error_state == 0
                                    ? "无故障"
                                    : engine1.error_state == 1
                                    ? "故障"
                                    : "--"
                        },
                        {
                            key: "冷冻出水温度设定值(℃)",
                            value: engine1
                                ? engine1.cryo_water_out_temp_set
                                : "--"
                        },
                        {
                            key: "当前负载率(%)",
                            value: engine1 ? engine1.load : "--"
                        },
                        {
                            key: "负载率限制设定(%)",
                            value: engine1 ? engine1.load_limit : "--"
                        },
                        {
                            key: "冷冻出水温度(℃)",
                            value: engine1 ? engine1.cryo_water_out_temp : "--"
                        },
                        {
                            key: "冷冻进水温度(℃)",
                            value: engine1 ? engine1.cryo_water_back_temp : "--"
                        },
                        {
                            key: "冷却出水温度(℃)",
                            value: engine1 ? engine1.cold_water_out_temp : "--"
                        },
                        {
                            key: "冷却进水温度(℃)",
                            value: engine1 ? engine1.cold_water_back_temp : "--"
                        },
                        {
                            key: "冷却出口压力(Mpa)",
                            value: engine1 ? engine1.cold_water_out_bar : "--"
                        },
                        {
                            key: "运行模式",
                            value:
                                engine1.run_mode == 1
                                    ? "制热"
                                    : engine1.run_mode == 2
                                    ? "制冷"
                                    : "制冰"
                        },
                        {
                            key: "蒸发器饱和冷媒压力(pa)",
                            value: engine1 ? engine1.evaporator_bar : "--"
                        },
                        {
                            key: "蒸发器饱和冷媒温度(℃)",
                            value: engine1 ? engine1.evaporator_temp : "--"
                        },
                        {
                            key: "冷凝器饱和冷媒压力(pa)",
                            value: engine1 ? engine1.condenser_bar : "--"
                        },
                        {
                            key: "冷凝器饱和冷媒温度(℃)",
                            value: engine1 ? engine1.condenser_temp : "--"
                        },
                        {
                            key: "油泵高压侧压力(pa)",
                            value: engine1 ? engine1.oil_pump_high_bar : "--"
                        },
                        {
                            key: "油泵低压侧压力(pa)",
                            value: engine1 ? engine1.oil_pump_low_bar : "--"
                        },
                        {
                            key: "油温(℃)",
                            value: engine1 ? engine1.oil_temp : "--"
                        },
                        {
                            key: "机组功率(W)",
                            value: engine1 ? engine1.engine_power : "--"
                        },
                        {
                            key: "冷冻水流开关",
                            value:
                                engine1.cryo_water_switch == 0
                                    ? "关"
                                    : engine1.cryo_water_switch == 1
                                    ? "开"
                                    : "--"
                        },
                        {
                            key: "冷却水流开关",
                            value:
                                engine1.cold_water_switch == 0
                                    ? "关"
                                    : engine1.cold_water_switch == 1
                                    ? "开"
                                    : "--"
                        },
                        {
                            key: "AB相电压(V)",
                            value: engine1 ? engine1.voltage_AB : "--"
                        },
                        {
                            key: "BC相电压(V)",
                            value: engine1 ? engine1.voltage_BC : "--"
                        },
                        {
                            key: "AC相电压(V)",
                            value: engine1 ? engine1.voltage_AC : "--"
                        },
                        {
                            key: "A相电压(V)",
                            value: engine1 ? engine1.voltage_A : "--"
                        },
                        {
                            key: "B相电压(V)",
                            value: engine1 ? engine1.voltage_B : "--"
                        },
                        {
                            key: "C相电压(V)",
                            value: engine1 ? engine1.voltage_C : "--"
                        },
                        {
                            key: "启动次数(次)",
                            value: engine1 ? engine1.start_count : "--"
                        },
                        {
                            key: "运行时间(秒)",
                            value: engine1 ? engine1.runtime_count : "--"
                        }
                    ];
                    this.zhilengzhuji2 = [
                        {
                            key: "运行状态",
                            value:
                                engine2.run_state == 0
                                    ? "停止"
                                    : engine2.run_state == 1
                                    ? "运行"
                                    : "--"
                        },
                        {
                            key: "故障状态",
                            value:
                                engine2.error_state == 0
                                    ? "无故障"
                                    : engine2.error_state == 1
                                    ? "故障"
                                    : "--"
                        },
                        {
                            key: "冷冻出水温度设定值(℃)",
                            value: engine2
                                ? engine2.cryo_water_out_temp_set
                                : "--"
                        },
                        {
                            key: "当前负载率(%)",
                            value: engine2 ? engine2.load : "--"
                        },
                        {
                            key: "负载率限制设定(%)",
                            value: engine2 ? engine2.load_limit : "--"
                        },
                        {
                            key: "冷冻出水温度(℃)",
                            value: engine2 ? engine2.cryo_water_out_temp : "--"
                        },
                        {
                            key: "冷冻进水温度(℃)",
                            value: engine2 ? engine2.cryo_water_back_temp : "--"
                        },
                        {
                            key: "冷却出水温度(℃)",
                            value: engine2 ? engine2.cold_water_out_temp : "--"
                        },
                        {
                            key: "冷却进水温度(℃)",
                            value: engine2 ? engine2.cold_water_back_temp : "--"
                        },
                        {
                            key: "冷却出口压力(Mpa)",
                            value: engine2 ? engine2.cold_water_out_bar : "--"
                        },
                        {
                            key: "运行模式",
                            value:
                                engine2.run_mode == 1
                                    ? "制热"
                                    : engine2.run_mode == 2
                                    ? "制冷"
                                    : "制冰"
                        },
                        {
                            key: "蒸发器饱和冷媒压力(pa)",
                            value: engine2 ? engine2.evaporator_bar : "--"
                        },
                        {
                            key: "蒸发器饱和冷媒温度(℃)",
                            value: engine2 ? engine2.evaporator_temp : "--"
                        },
                        {
                            key: "冷凝器饱和冷媒压力(pa)",
                            value: engine2 ? engine2.condenser_bar : "--"
                        },
                        {
                            key: "冷凝器饱和冷媒温度(℃)",
                            value: engine2 ? engine2.condenser_temp : "--"
                        },
                        {
                            key: "油泵高压侧压力(pa)",
                            value: engine2 ? engine2.oil_pump_high_bar : "--"
                        },
                        {
                            key: "油泵低压侧压力(pa)",
                            value: engine2 ? engine2.oil_pump_low_bar : "--"
                        },
                        {
                            key: "油温(℃)",
                            value: engine2 ? engine2.oil_temp : "--"
                        },
                        {
                            key: "机组功率(W)",
                            value: engine2 ? engine2.engine_power : "--"
                        },
                        {
                            key: "冷冻水流开关",
                            value:
                                engine2.cryo_water_switch == 0
                                    ? "关"
                                    : engine2.cryo_water_switch == 1
                                    ? "开"
                                    : "--"
                        },
                        {
                            key: "冷却水流开关",
                            value:
                                engine2.cold_water_switch == 0
                                    ? "关"
                                    : engine2.cold_water_switch == 1
                                    ? "开"
                                    : "--"
                        },
                        {
                            key: "AB相电压(V)",
                            value: engine2 ? engine2.voltage_AB : "--"
                        },
                        {
                            key: "BC相电压(V)",
                            value: engine2 ? engine2.voltage_BC : "--"
                        },
                        {
                            key: "AC相电压(V)",
                            value: engine2 ? engine2.voltage_AC : "--"
                        },
                        {
                            key: "A相电压(V)",
                            value: engine2 ? engine2.voltage_A : "--"
                        },
                        {
                            key: "B相电压(V)",
                            value: engine2 ? engine2.voltage_B : "--"
                        },
                        {
                            key: "C相电压(V)",
                            value: engine2 ? engine2.voltage_C : "--"
                        },
                        {
                            key: "启动次数(次)",
                            value: engine2 ? engine2.start_count : "--"
                        },
                        {
                            key: "运行时间(秒)",
                            value: engine2 ? engine2.runtime_count : "--"
                        }
                    ];
                    this.zhilengzhuji3 = [
                        {
                            key: "运行状态",
                            value:
                                engine3.run_state == 0
                                    ? "停止"
                                    : engine3.run_state == 1
                                    ? "运行"
                                    : "--"
                        },
                        {
                            key: "故障状态",
                            value:
                                engine3.error_state == 0
                                    ? "无故障"
                                    : engine3.error_state == 1
                                    ? "故障"
                                    : "--"
                        },
                        {
                            key: "冷冻出水温度设定值(℃)",
                            value: engine3
                                ? engine3.cryo_water_out_temp_set
                                : "--"
                        },
                        {
                            key: "当前负载率(%)",
                            value: engine3 ? engine3.load : "--"
                        },
                        {
                            key: "负载率限制设定(%)",
                            value: engine3 ? engine3.load_limit : "--"
                        },
                        {
                            key: "冷冻出水温度(℃)",
                            value: engine3 ? engine3.cryo_water_out_temp : "--"
                        },
                        {
                            key: "冷冻进水温度(℃)",
                            value: engine3 ? engine3.cryo_water_back_temp : "--"
                        },
                        {
                            key: "冷却出水温度(℃)",
                            value: engine3 ? engine3.cold_water_out_temp : "--"
                        },
                        {
                            key: "冷却进水温度(℃)",
                            value: engine3 ? engine3.cold_water_back_temp : "--"
                        },
                        {
                            key: "冷却出口压力(Mpa)",
                            value: engine3 ? engine3.cold_water_out_bar : "--"
                        },
                        {
                            key: "运行模式",
                            value:
                                engine3.run_mode == 1
                                    ? "制热"
                                    : engine3.run_mode == 2
                                    ? "制冷"
                                    : "制冰"
                        },
                        {
                            key: "蒸发器饱和冷媒压力(pa)",
                            value: engine3 ? engine3.evaporator_bar : "--"
                        },
                        {
                            key: "蒸发器饱和冷媒温度(℃)",
                            value: engine3 ? engine3.evaporator_temp : "--"
                        },
                        {
                            key: "冷凝器饱和冷媒压力(pa)",
                            value: engine3 ? engine3.condenser_bar : "--"
                        },
                        {
                            key: "冷凝器饱和冷媒温度(℃)",
                            value: engine3 ? engine3.condenser_temp : "--"
                        },
                        {
                            key: "油泵高压侧压力(pa)",
                            value: engine3 ? engine3.oil_pump_high_bar : "--"
                        },
                        {
                            key: "油泵低压侧压力(pa)",
                            value: engine3 ? engine3.oil_pump_low_bar : "--"
                        },
                        {
                            key: "油温(℃)",
                            value: engine3 ? engine3.oil_temp : "--"
                        },
                        {
                            key: "机组功率(W)",
                            value: engine3 ? engine3.engine_power : "--"
                        },
                        {
                            key: "冷冻水流开关",
                            value:
                                engine3.cryo_water_switch == 0
                                    ? "关"
                                    : engine3.cryo_water_switch == 1
                                    ? "开"
                                    : "--"
                        },
                        {
                            key: "冷却水流开关",
                            value:
                                engine3.cold_water_switch == 0
                                    ? "关"
                                    : engine3.cold_water_switch == 1
                                    ? "开"
                                    : "--"
                        },
                        {
                            key: "AB相电压(V)",
                            value: engine3 ? engine3.voltage_AB : "--"
                        },
                        {
                            key: "BC相电压(V)",
                            value: engine3 ? engine3.voltage_BC : "--"
                        },
                        {
                            key: "AC相电压(V)",
                            value: engine3 ? engine3.voltage_AC : "--"
                        },
                        {
                            key: "A相电压(V)",
                            value: engine3 ? engine3.voltage_A : "--"
                        },
                        {
                            key: "B相电压(V)",
                            value: engine3 ? engine3.voltage_B : "--"
                        },
                        {
                            key: "C相电压(V)",
                            value: engine3 ? engine3.voltage_C : "--"
                        },
                        {
                            key: "启动次数(次)",
                            value: engine3 ? engine3.start_count : "--"
                        },
                        {
                            key: "运行时间(秒)",
                            value: engine3 ? engine3.runtime_count : "--"
                        }
                    ];
                    this.zhilengzhujizong = [];
                    for (var i = 0; i < this.zhilengzhuji1.length; i++) {
                        let item = {};
                        item.key = this.zhilengzhuji1[i].key;
                        item.value1 = this.zhilengzhuji1[i].value;
                        item.value2 = this.zhilengzhuji2[i].value;
                        item.value3 = this.zhilengzhuji3[i].value;
                        this.zhilengzhujizong.push(item);
                    }
                }
            });
        },
        getCryoPunmp() {
            //冷冻泵
            api.getCryoPunmp([
                "ldb_togethercryo_punmp-1",
                "ldb_togethercryo_punmp-2",
                "ldb_togethercryo_punmp-3",
                "ldb_togethercryo_punmp-4"
            ]).then(res => {
                if (res) {
                    const data1 = res.bus_json["ldb_togethercryo_punmp-1"];
                    //冷冻泵1#出口压力
                    this.datasP[7].py = data1 ? data1.out_bar : "--";
                    const data2 = res.bus_json["ldb_togethercryo_punmp-2"];
                    //冷冻泵2#出口压力
                    this.datasP[6].p = data2 ? data2.out_bar : "--";
                    const data3 = res.bus_json["ldb_togethercryo_punmp-3"];
                    //冷冻泵3#出口压力
                    this.datasP[5].p = data3 ? data3.out_bar : "--";
                    const data4 = res.bus_json["ldb_togethercryo_punmp-4"];
                    //冷冻泵4#出口压力
                    this.datasP[4].p = data4 ? data4.out_bar : "--";
                    //状态
                    this.datasState[10].run_state = data4
                        ? data4.run_state
                        : "--";
                    this.datasState[10].error_state = data4
                        ? data4.error_state
                        : "--";
                    this.datasState[11].run_state = data3
                        ? data3.run_state
                        : "--";
                    this.datasState[11].error_state = data3
                        ? data3.error_state
                        : "--";
                    this.datasState[12].run_state = data2
                        ? data2.run_state
                        : "--";
                    this.datasState[12].error_state = data2
                        ? data2.error_state
                        : "--";
                    this.datasState[13].run_state = data1
                        ? data1.run_state
                        : "--";
                    this.datasState[13].error_state = data1
                        ? data1.error_state
                        : "--";
                    this.lengdongbeng4 = [
                        {
                            key: "运行状态",
                            value:
                                data4.run_state == 0
                                    ? "停止"
                                    : data4.run_state == 1
                                    ? "运行"
                                    : "--"
                        },
                        {
                            key: "本地/远控状态",
                            value:
                                data4.local_remote_state == 0
                                    ? "本地"
                                    : data4.local_remote_state == 1
                                    ? "远控"
                                    : "--"
                        },
                        {
                            key: "故障状态",
                            value:
                                data4.error_state == 0
                                    ? "无故障"
                                    : data4.local_remote_state == 1
                                    ? "故障"
                                    : "--"
                        },
                        {
                            key: "出口压力(MPa)",
                            value: data4 ? data4.out_bar : "--"
                        },
                        {
                            key: "变频运行频率(Hz)",
                            value: data4 ? data4.frequency : "--"
                        }
                    ];
                    this.lengdongbeng3 = [
                        {
                            key: "运行状态",
                            value:
                                data3.run_state == 0
                                    ? "停止"
                                    : data3.run_state == 1
                                    ? "运行"
                                    : "--"
                        },
                        {
                            key: "本地/远控状态",
                            value:
                                data3.local_remote_state == 0
                                    ? "本地"
                                    : data3.local_remote_state == 1
                                    ? "远控"
                                    : "--"
                        },
                        {
                            key: "故障状态",
                            value:
                                data3.error_state == 0
                                    ? "无故障"
                                    : data3.local_remote_state == 1
                                    ? "故障"
                                    : "--"
                        },
                        {
                            key: "出口压力(MPa)",
                            value: data3 ? data3.out_bar : "--"
                        },
                        {
                            key: "变频运行频率(Hz)",
                            value: data3 ? data3.frequency : "--"
                        }
                    ];
                    this.lengdongbeng2 = [
                        {
                            key: "运行状态",
                            value:
                                data2.run_state == 0
                                    ? "停止"
                                    : data2.run_state == 1
                                    ? "运行"
                                    : "--"
                        },
                        {
                            key: "本地/远控状态",
                            value:
                                data2.local_remote_state == 0
                                    ? "本地"
                                    : data2.local_remote_state == 1
                                    ? "远控"
                                    : "--"
                        },
                        {
                            key: "故障状态",
                            value:
                                data2.error_state == 0
                                    ? "无故障"
                                    : data2.local_remote_state == 1
                                    ? "故障"
                                    : "--"
                        },
                        {
                            key: "出口压力(MPa)",
                            value: data2 ? data2.out_bar : "--"
                        },
                        {
                            key: "变频运行频率(Hz)",
                            value: data2 ? data2.frequency : "--"
                        }
                    ];
                    this.lengdongbeng1 = [
                        {
                            key: "运行状态",
                            value:
                                data1.run_state == 0
                                    ? "停止"
                                    : data1.run_state == 1
                                    ? "运行"
                                    : "--"
                        },
                        {
                            key: "本地/远控状态",
                            value:
                                data1.local_remote_state == 0
                                    ? "本地"
                                    : data1.local_remote_state == 1
                                    ? "远控"
                                    : "--"
                        },
                        {
                            key: "故障状态",
                            value:
                                data1.error_state == 0
                                    ? "无故障"
                                    : data1.local_remote_state == 1
                                    ? "故障"
                                    : "--"
                        },
                        {
                            key: "出口压力(MPa)",
                            value: data1 ? data1.out_bar : "--"
                        },
                        {
                            key: "变频运行频率(Hz)",
                            value: data1 ? data1.frequency : "--"
                        }
                    ];

                    this.lengdongbengzong = [];
                    for (var i = 0; i < this.lengdongbeng1.length; i++) {
                        let item = {};
                        item.key = this.lengdongbeng1[i].key;
                        item.value1 = this.lengdongbeng1[i].value;
                        item.value2 = this.lengdongbeng2[i].value;
                        item.value3 = this.lengdongbeng3[i].value;
                        item.value4 = this.lengdongbeng4[i].value;
                        this.lengdongbengzong.push(item);
                    }
                }
            });
        },
        showdialog(item) {
            this.biaoNumber = item.point_id;
            this.dialogTitle = item.name;
            this.detailVisible = true;
        },
        setImgSize() {
            if (window.innerWidth >= 2560) {
                this.basisUnitH = 1.2;
                this.basisUnitV = 1.2;
            } else if (window.innerWidth < 2560 && window.innerWidth >= 1900) {
                this.basisUnitH = 1.0;
                this.basisUnitV = 0.82;
                console.log("1920----------" + this.basisUnitH);
            } else if (window.innerWidth < 1920 && window.innerWidth >= 1660) {
                this.basisUnitH = 0.82;
                this.basisUnitV = 0.82;
                console.log("1680----------" + this.basisUnitH);
            } else if (window.innerWidth < 1660 && window.innerWidth >= 1420) {
                this.basisUnitH = 0.7;
                this.basisUnitV = 0.7;
                console.log("1440----------" + this.basisUnitH);
            } else if (window.innerWidth < 1420 && window.innerWidth >= 1220) {
                this.basisUnitH = 0.6;
                this.basisUnitV = 0.6;
                console.log("1366----------" + this.basisUnitH);
            } else {
            }
        },
        zoom() {
            let vm = this;
            if (navigator.userAgent.indexOf("Firefox") != -1) {
                //FF
                document.getElementById("main").addEventListener(
                    "DOMMouseScroll",
                    function(event) {
                        event = event || window.event;
                        if (event.detail > 0) {
                            vm.scale =
                                vm.scale > 0.2 ? vm.scale - 0.1 : vm.scale;
                        } else {
                            vm.scale += 0.1;
                        }
                        event.cancelBubble = true;
                        event.stopPropagation();
                        event.preventDefault();
                    },
                    false
                );
            } else {
                //非FF
                document.getElementById("main").onmousewheel = function(event) {
                    event = event || window.event;
                    if (event.deltaY > 0) {
                        vm.scale = vm.scale > 0.2 ? vm.scale - 0.1 : vm.scale;
                    } else {
                        vm.scale += 0.1;
                    }
                    event.cancelBubble = true;
                    event.stopPropagation();
                    event.preventDefault();
                };
            }
        },
        drag() {
            let oDiv = this.$refs.canvas;
            let vm = this;
            oDiv.onmousedown = function(en) {
                let ev = ev || event;
                let disX = en.clientX - oDiv.offsetLeft;
                let disY = en.clientY - oDiv.offsetTop;
                oDiv.onmousemove = function(en) {
                    let ev = ev || event;
                    if (
                        en.clientY > 0 &&
                        en.clientY < vm.$refs.main.clientHeight &&
                        en.clientX > 0 &&
                        en.clientX < vm.$refs.main.clientWidth
                    ) {
                        vm.top = en.clientY - disY;
                        vm.left = en.clientX - disX;
                    }
                };
                oDiv.onmouseup = function() {
                    oDiv.onmousemove = null;
                };
                return false;
            };
        }
    },
    beforeDestroy() {
        clearInterval(this.timer);
    }
};
</script>
<style lang="scss">
.el-popover {
    background: #06253f !important;
    border: 0;
    color: #56fbff;
    width: auto !important;
    .popupwrapper {
        height: 500px;
        width: 100%;
        overflow-y: auto;
        display: flex;
        flex-flow: row wrap;

        .popupdiv {
            border-bottom: 1px dotted #a0a0a0;
            padding: 0.5rem 0;
            width: 33%;
            //overflow-y: auto;
            i {
                font-weight: bold;
            }
        }
    }
}

.container-monitor-wrapper {
    width: 100%;
    height: 100%;
    color: #fff;
    padding: 0 2rem 2rem 2rem;
    padding-top: 0;
    box-sizing: border-box;
    position: relative;

    h2 {
        color: #fff;
        line-height: 1.8rem;
        text-indent: 2.5rem;
        font-size: 16px;
        float: left;
    }

    .bg-img-wrap {
        margin: 0 auto;
        text-align: center;
        align-self: center;
        width: 100%;
        height: 100%;
        background: url(../../../../assets/image/leaderpage/wei-diagram-bg.png)
            no-repeat;
        background-size: 100% 100%;
        position: relative;

        .tab_item_select {
            background: url(../../../../assets/image/leaderpage/tb22.png)
                no-repeat;
            background-size: 100% 100%;
            height: 2rem;
            line-height: 2rem;
            width: 5rem;
            text-align: center;
            font-size: 0.8rem;
            // margin-left: 10px;
            display: inline-block;
            color: #fff;
            background-color: transparent !important;
            padding: 0 !important;
            cursor: pointer;
            position: absolute;
            top: 15%;
            left: 5%;
            z-index: 999;
        }

        .update-time {
            position: absolute;
            top: -1%;
            left: 11%;
            font-size: 0.8rem;
            color: #fff;
        }

        .lengqueta {
            width: 9.5rem;
            height: auto;
            position: absolute;
            cursor: pointer;
        }

        .lengquebeng {
            width: 2.3rem;
            height: auto;
            position: absolute;
            cursor: pointer;
        }

        .zhileng {
            width: 6.5rem;
            height: auto;
            position: absolute;
            cursor: pointer;
        }

        .total-wrap {
            top: 0%;
            left: 0%;
            width: 98%;
            height: 95%;
            position: relative;
            overflow: hidden;
            cursor: move;

            .canvas-wrap {
                padding: 2rem;
                width: 100%;
                position: absolute;
                left: 0;
                top: 0;

                .bg-img {
                    width: 100%;
                    height: 100%;
                }
            }

            .top-switch {
                // cursor: pointer;
                transform: scale(0.62);
                position: absolute;
                text-align: center;
                display: flex;
                height: 20%;
                overflow: hidden;

                .top-title {
                    align-self: center;
                    margin-left: 0.7rem;
                    font-size: 0.8rem;
                }
            }

            .bottom-switch {
                // cursor: pointer;
                transform: scale(1);
                position: absolute;
                text-align: center;
                display: flex;
                height: 20%;
                overflow: hidden;

                .bottom-title {
                    align-self: center;
                    margin-left: 0.7rem;
                    font-size: 0.8rem;
                }
            }

            .data-wrap {
                position: absolute;
                display: grid;

                .data-item {
                    display: flex;
                    margin-bottom: 0.2rem;

                    .data-name {
                        align-self: center;
                        font-size: 0.8rem;
                        margin-right: 0.55rem;
                        width: 1.4rem;
                        text-align: right;
                    }

                    .data-number {
                        font-size: 0.8rem;
                        width: 6rem;
                        text-align: right;
                        background-color: #a1c8fe;
                        color: #000;
                        height: 1rem;
                        line-height: 1rem;

                        span {
                            display: inline-block;
                            margin-left: 0.2rem;
                            margin-right: 0.1rem;
                            font-size: 0.5rem;
                        }
                    }

                    .data-u {
                        height: 1.1rem;
                        line-height: 1.1rem;
                    }

                    .data-name-u {
                        font-size: 0.9rem;
                        margin-right: 1rem;
                    }
                }
            }
        }
    }

    .red {
        color: #fe0101;
    }

    .yellow {
        color: #fefa00;
    }

    .green {
        color: #00b200;
    }

    .scale-on-off {
        transform: scale(0.5);
    }
}
</style>
